export const HaveNitrateMedication = 'HaveNitrateMedication';
export const HaveAttentionFollowConsultation = 'HaveAttentionFollowConsultation';
export const EvaluationQuestions = 'EvaluationQuestions';
export const NationalityCard = 'NationalityCard';